import React from "react";

const Spinner = () => {
    const spinnerStyle = {
        width: "20px",
        height: "20px",
        border: "3px solid #4caf50", 
        borderTop: "3px solid transparent",
        borderRadius: "50%", 
        animation: "spin 1s linear infinite", 
        marginLeft: "16px",
    };

    return (
        <div
            style={{
                ...spinnerStyle,
                animationName: "spin",
                animationDuration: "1s",
                animationTimingFunction: "linear",
                animationIterationCount: "infinite",
            }}
        />
    );
};

export default Spinner;